import { posts as generatedPosts } from "../generated/posts";

export interface PostMetadata {
  slug: string;
  title: string;
  date: string;
  description: string;
  tags: string[];
  project?: string;
}

export interface Post extends PostMetadata {
  content: string;
  htmlContent: string;
}

export interface TableOfContentsItem {
  id: string;
  text: string;
  level: number;
}

// Get all post metadata
export async function getAllPosts(): Promise<PostMetadata[]> {
  return generatedPosts.map(post => ({
    slug: post.slug,
    title: post.title,
    date: post.date,
    description: post.description,
    tags: post.tags,
    project: post.project,
  }));
}

// Get a single post by slug
export async function getPostBySlug(slug: string): Promise<Post | null> {
  const post = generatedPosts.find(p => p.slug === slug);
  return post || null;
}

// Extract table of contents from markdown content
export function extractTableOfContents(htmlContent: string): TableOfContentsItem[] {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = htmlContent;

  const headings = tempDiv.querySelectorAll('h2, h3');
  const toc: TableOfContentsItem[] = [];

  headings.forEach((heading, index) => {
    const text = heading.textContent || '';
    const level = parseInt(heading.tagName.substring(1));
    const id = text.toLowerCase().replace(/[^\w]+/g, '-');

    // Add ID to heading for anchor links
    heading.id = id;

    toc.push({
      id,
      text,
      level,
    });
  });

  return toc;
}

// Format date for display
export function formatDate(dateString: string): string {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}
